module.exports = __webpack_public_path__ + "static/media/marker_car.201fd393.svg";